import { useEffect } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './app/router/router';
import ErrorBoundary from 'shared/feedback/ErrorBoundary';
import { QueryClientProvider } from '@tanstack/react-query';
import Toasts from 'shared/feedback/toasts/Toasts';
import { createQueryClient } from 'app/queryClient';
import './App.scss';

const queryClient = createQueryClient();

function App() {
  // Prevent the browser from navigating to a file that the user drops outside
  // any registered dropzone (e.g. on the dashboard when the import popover is closed).
  // Dropzones like FileZone call stopPropagation, so handled drops never reach these listeners.
  useEffect(() => {
    const isFileDrag = (e: DragEvent) => e.dataTransfer?.types?.includes('Files');
    const preventFileDefault = (e: DragEvent) => {
      if (isFileDrag(e)) e.preventDefault();
    };
    window.addEventListener('dragover', preventFileDefault);
    window.addEventListener('drop', preventFileDefault);
    return () => {
      window.removeEventListener('dragover', preventFileDefault);
      window.removeEventListener('drop', preventFileDefault);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <RouterProvider router={router} />
        {/* Outside the router: Toasts uses no routing hooks, and RouterProvider takes no children. */}
        <Toasts />
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
